import React from "react";

import * as _ from "lodash";

const TextInput = ({ input, meta, ...otherProps }) => {
  const inputElementRef = React.createRef();

  return (
    <div
      className={
        ((otherProps.prependValue || otherProps.appendValue) &&
        !otherProps.caption
          ? "form-group input-group"
          : "form-group") +
        " text-left " +
        (otherProps.containerStyle || "")
      }>
      {otherProps.label && <label>{otherProps.label}</label>}
      {otherProps.prependValue && (
        <div className="input-group-prepend">
          <span className="input-group-text">{otherProps.prependValue}</span>
        </div>
      )}
      <input
        ref={inputElementRef}
        className={`form-control ${otherProps.inputClass} ${
          meta.error && meta.touched ? "is-invalid" : ""
        }`}
        {...input}
        onChange={(e) => {
          if (otherProps.onChange) otherProps.onChange(e);
          input.onChange(e);
        }}
        min={otherProps.min}
        max={otherProps.max}
        autoCapitalize={otherProps.autoCapitalize || "off"}
        pattern={otherProps.pattern}
        autofill={otherProps.autofill}
        type={otherProps.type || "text"}
        placeholder={otherProps.placeholder}
      />
      {otherProps.appendValue && (
        <div className="input-group-append">
          <span className="input-group-text">
            {_.isFunction(otherProps.appendValue)
              ? otherProps.appendValue(inputElementRef)
              : otherProps.appendValue}
          </span>
        </div>
      )}
      {otherProps.caption && (
        <small className="form-text text-muted mt-1">
          <i>{otherProps.caption}</i>
        </small>
      )}
      {meta.error && meta.touched && (
        <div className="invalid-feedback">{meta.error}</div>
      )}
    </div>
  );
};

export { TextInput };
